//'use strict';


var additionalRequirementsForModule = [ 'ui.bootstrap' ];
Array.prototype.push.apply(bookModule.requires, additionalRequirementsForModule);


bookModule.controller('curriculumControllerRH16', 
    ['$scope', '$controller', 'getChapterConfig', '$location', '$state', '$document', '$uibModal',
    function ($scope, $controller, getChapterConfig, $location, $state, $document, $uibModal) {
        // Initialize the parent class and extend it.
        angular.extend(this, $controller('curriculumController', {$scope: $scope}) );
        var vm = $scope.ctrl;

        /** @Override
         * Prevent this method being used as there are no Core Skills nodes in RH16 unit
         */
        vm.isAnyCoreSkillOpen = function() { }

        /** @Override
         *  Prevent Core Skills check from occuring as there are no Core Skills nodes in RH16 unit
         */
        vm.getDeepestSelectedState = function () {
            if (vm.isAnyCriteriaOpen())
                return "training";
            if (vm.isAnyOutcomeOpen())
                return "outcome";
            if (vm.isAnyDomainOpen())
                return "domain";
            return "none";
        }
        
        /** @Override
         * Prevent Core Skills from being passed from the URL as there are Core Skills nodes in RH16 unit
         */
        vm.parseSkillUrlStringToSkillIndex = function(chapterStringArray) { };

        
        /** @Override
         * returns the Outcome index (int) associated with the current Outcome in the url
         */
        vm.parseOutcomeUrlStringToOutcomeIndex = function(chapterStringArray) {
            if (chapterStringArray == undefined)  return undefined;
            var outcomeString = chapterStringArray[1];
            var outcomeIndex = outcomeString == undefined ? undefined : parseInt(outcomeString)-1;
            return outcomeIndex;
        };


        /** @Override
         * Prevent this method being used as there are no Core Skills nodes in RH16 unit
         */
        vm.getOpenContentNode = function() {
            if (vm.isAnyCriteriaOpen())
                return vm.getOpenTrainingContentNode();
            if (vm.isAnyOutcomeOpen())
                return vm.getOpenOutcomeContentNode();
            if (vm.isAnyDomainOpen())
                return vm.getOpenDomainContentNode();
            return undefined;
        };

        /** @Override
         * Prevent this method accidentally being used as there are no Core Skills nodes in RH16 unit
         */
        vm.getOpenCoreSkillContentNode = function() { }
        
        /** @Override
         * Alter the outcome content node to come from a parent Domain node instead of parent Core Skill node  as there are no Core Skills nodes in RH16 unit
         */
        vm.getOpenOutcomeContentNode = function() {
            if (vm.openOutcomeIndex == undefined) return undefined;
            var openDomainNode = vm.getOpenDomainContentNode();
            if (openDomainNode == undefined) return undefined;
            var outcomeContentNode = openDomainNode.children[vm.openOutcomeIndex];
            return outcomeContentNode;
        };
    } ]
);